import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'

import { Loader } from 'src/components/loader'
import { useRedirectURLs } from 'src/hooks/redirect-urls/use-redirect-urls.hook'
import { ROUTES, STORAGE_KEYS } from 'src/constants'

export const DefaultRedirect = () => {
  const { data: urls, isLoading, isFetching, isFetched } = useRedirectURLs()
  const [redirectUrl, setRedirectUrl] = useState<null | string>(null)

  useEffect(() => {
    if (isLoading || isFetching || !isFetched) {
      return
    }
    if (urls?.data) {
      const currentUrl = window.location.href

      const matchedUrl = urls.data.find((url) => url.redirect_url === currentUrl && url.active)

      if (matchedUrl) {
        setRedirectUrl(matchedUrl.redirect_target)
      } else {
        setRedirectUrl('')
      }
    }
  }, [urls, isFetching, isFetched, isLoading])

  if (isLoading || isFetching || !isFetched) {
    return <Loader />
  }

  if (redirectUrl) {
    window.location.replace(redirectUrl)
    return null
  }

  if (!isFetching && isFetched && !isLoading && redirectUrl === '') {
    const lastRoute = localStorage.getItem(STORAGE_KEYS.LAST_ROUTE)
    if (lastRoute && lastRoute !== '/') {
      return <Navigate to={lastRoute} replace />
    }
    return <Navigate to={`/${ROUTES.ACCOUNTS}`} replace />
  }

  return <Loader />
}
